import React, { useEffect, useState } from 'react'
import "./Navbar.css"
import { GiHamburgerMenu } from "react-icons/gi";
import { RxCross2 } from "react-icons/rx";
import {Link} from "react-scroll"

function Navbar () {
    const [ display, setDisplay ] = useState(false)
    const [ sticky, setSticky ] = useState(false)

    useEffect(() => {
        const handleScroll = () => {
            setSticky(window.scrollY > -1);
        }
        window.addEventListener("scroll", handleScroll)
        return () => window.removeEventListener('scroll',handleScroll)
    })

  return (
      <div className={`${sticky ? 'sticky navbar': "navbar"}`}>
          <div className='n-container'>
              <div className="n-left">
                  <span>K</span>idan
              </div>
              <div className="n-right">
                  <ul>
                      <Link spy={true} to={"Navbar"} smooth={true} activeClass="active">
                          <li>Home</li>
                      </Link>
                      <Link spy={true} to={"About"} smooth={true} >
                          <li>About</li>
                      </Link>
                      <Link spy={true} to={"Portfolio"} smooth={true} >
                            <li>Portfolio</li>
                      </Link>
                      <Link spy={true} to={"Contact"} smooth={true} >
                            <li>Contact</li>
                      </Link>
                  </ul>
                  {!display && <div className="icon" onClick={()=>setDisplay(true)}>
                      <GiHamburgerMenu />
                  </div>}
                  {display && <div className='iconx' onClick={() => setDisplay(false)}>
                      <RxCross2 />
                  </div>} 
                  {display&&<div className="M-ul">
                      <ul>
                          <Link spy={true} to={"Navbar"} smooth={true} activeClass="active">
                              <li>Home</li>
                          </Link>
                          <Link spy={true} to={"About"} smooth={true} >
                              <li>About</li>
                          </Link>
                          <Link spy={true} to={"Portfolio"} smooth={true} >
                              <li>Portfolio</li>
                          </Link>
                          <Link spy={true} to={"Contact"} smooth={true} >
                              <li>Contact</li>
                          </Link>
                      </ul>
                  </div>}
              </div>
          </div>
    </div>
  )
}

export default Navbar